import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ISelectValue } from "~app/common/models/selectValueModel";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { ForkalkylsmallQueryResponseDTO } from "~app/features/virkeskop/forkalkylsmallar/models/ForkalkylsmallQueryResponseDTO";
import { TilldelaHandelssortimentsGruppDTO } from "~app/features/virkeskop/forkalkylsmallar/models/TilldelaHandelssortimentsGruppDTO";

@Injectable({
    providedIn: "root"
})
export class ForkalkylmallarService {
    private readonly apiClientService = inject(ApiClientService);

    getHandelssortimentGrupper(): Observable<TilldelaHandelssortimentsGruppDTO[]> {
        return this.apiClientService.get<TilldelaHandelssortimentsGruppDTO[]>("mina/forkalkylsmallar/GetAllTilldelaHandelssortimentsGrupper");
    }

    getMinaHandelssortiment(allowCache: boolean): Observable<ISearchHandelssortimentModel[]> {
        return this.apiClientService.get<ISearchHandelssortimentModel[]>("mina/handelssortiment", false, { cache: allowCache });
    }

    getMinaForkalkylsmallar(): Observable<ForkalkylsmallQueryResponseDTO[]> {
        return this.apiClientService.get(`mina/forkalkylsmallar/`, false);
    }

    getVarden(): Observable<ISelectValue[]> {
        return this.apiClientService.get<ISelectValue[]>(`varden`, false, { cache: true });
    }

    getVardenByGrupp(grupp: string): Observable<ISelectValue[]> {
        return this.getVarden().pipe(map(v => v.filter(g => g.grupp === grupp)));
    }
}
